import React from 'react';
import './FloatTarget.css';

export function FloatTarget() {
  return (
    <div className="float-target">
      <img
        src="/images/aimers_target_3d.jpg"
        alt="AIMERS 3D Target"
        className="float-target__img"
      />
    </div>
  );
}
